import { getField, updateField } from 'vuex-map-fields';
import moment from 'moment';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    clienteId: 0,
    cliente: null,
    clienteNombre: null,
    periodo: new Date(1900, 1, 1),
    rowVersion: null,
    
    condiciones: [],
};

const mutations = {
    updateField,

    'INICIALIZAR' (state) {
        state.id = 0;
        state.clienteId = 0;
        state.cliente = null;
        state.clienteNombre = null;
        state.periodo = new Date(1900, 1, 1),
        state.rowVersion = null;

        state.condiciones = [];
    },
    'SET_REBATE' (state, clienteRebate) {
        state.id = clienteRebate.id;
        state.rowVersion = clienteRebate.rowVersion;
        
        if (clienteRebate.condiciones) {
            state.condiciones = clienteRebate.condiciones;
        } else {
            state.condiciones = [];
        }
    },
    'SET_CLIENTE' (state, cliente) {
        state.cliente = cliente;
        if (cliente) {
            state.clienteId = cliente.id? cliente.id : 0;
            state.clienteNombre = cliente.nombre? cliente.nombre.trim() : null;
        } else {
            state.clienteId = 0;
            state.clienteNombre = null;
        }
    },
    'SET_PERIODO' (state, periodo) {
        state.periodo = periodo;
    },
    'ADD_CONDICION' (state, condicion) {
        // /* Actualizamos el monto maximo de la condicion anterior */
        // let condicionActual = state.condiciones
        //     .find(t => t.montoMaximo == 0);
        
        // if (condicionActual) {
        //     condicionActual.montoMaximo = condicion.montoMinimo;
        // }

        condicion.id = 0;
        if (state.condiciones.length != 0) {
            condicion.montoMinimo = Math.max(...state.condiciones.map(t => t.montoMaximo), 0);
        } else {
            condicion.montoMinimo = 0;
        }

        state.condiciones.push(condicion);
    },
    'UPDATE_CONDICION' (state, params) {
        let condicion = state.condiciones
            .find(condicion => condicion == params.condicion);

        if (condicion) {
            condicion.pjeRebate = params.pjeRebate;
        }
    },
    'REMOVE_CONDICION' (state) {
        if (state.condiciones) {
            if (state.condiciones.length != 0) {
                let itemKey = state.condiciones
                    .findIndex(t => t.montoMaximo == 0);
                
                if (itemKey != -1) {
                    state.condiciones.splice(itemKey, 1);
                } else {
                    let maximo = Math.max(...state.condiciones.map(t => t.montoMaximo), 0);
            
                    /* Eliminamos la última condición */
                    itemKey = state.condiciones
                        .findIndex(t => t.montoMaximo == maximo);
                    
                    if (itemKey != -1) {
                        state.condiciones.splice(itemKey, 1);
                    }
                }
        
                // /* Actualizamos los datos de la (nueva) última condición */
                // if (state.condiciones.length != 0) {
                //     let maximo = Math.max(...state.condiciones.map(t => t.montoMaximo), 0);

                //     let condicion = state.condiciones
                //         .find(t => t.montoMaximo == maximo);
                    
                //     if (condicion) {
                //         condicion.montoMaximo = 0;
                //     }
                // }
            }
        }
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit } ) {
        commit('INICIALIZAR');
    },
    setCliente ( { commit }, cliente ) {
        commit('SET_CLIENTE', cliente);
    },
    setPeriodo ( { commit }, periodo ) {
        commit('SET_PERIODO', periodo);
    },
    getClienteRebate ( { commit } ) {
        return new Promise((resolve, reject) => {
            let anio = moment(state.periodo).format('YYYY');

            apiAxios.get('clientes/' + state.clienteId + '/rebate/' + anio + '/abm')
                .then(res => {
                    commit('SET_REBATE', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let condiciones = state.condiciones.map(condicion => ({
                id: parseInt(condicion.id),
                montoMinimo: parseFloat(condicion.montoMinimo),
                montoMaximo: parseFloat(condicion.montoMaximo),
                pjeRebate: parseFloat(condicion.pjeRebate),
            }))

            let clienteRebate= {
                clienteId: state.clienteId,
                anio: moment(state.periodo).format('YYYY'),
                condiciones
            }

            let url = 'clientes/' + state.clienteId + '/rebate';
            if (state.id != 0) {
                url += '/' + state.id;
                clienteRebate.rowVersion = state.rowVersion;
            }

            apiAxios.post(url, clienteRebate)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    addCondicion ( { commit }, condicion ) {
        commit('ADD_CONDICION', condicion);
    },
    updateCondicion ( { commit }, params ) {
        commit('UPDATE_CONDICION', params);
    },
    removeCondicion ( { commit } ) {
        commit('REMOVE_CONDICION');
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}